export const sharedLocale = {
  // Grid
  'common.grid.columnName.actions': 'Actions',

  // Buttons
  'common.button.confirm': 'Confirm',
  'common.button.saving': 'Saving',

  // Gateway Protocol Monitor
  'app.gatewayProtocolMonitor.copyPayload': 'Copy payload',
  'app.gatewayProtocolMonitor.copiedPayload': 'Copied',
  'app.gatewayProtocolMonitor.copiedPayloadTooltip': 'Copied payload to clipboard',
};
